import { render, staticRenderFns } from "./EditAccountSecurity.vue?vue&type=template&id=1bfb5270&scoped=true"
import script from "./EditAccountSecurity.vue?vue&type=script&lang=ts"
export * from "./EditAccountSecurity.vue?vue&type=script&lang=ts"
import style0 from "./EditAccountSecurity.vue?vue&type=style&index=0&id=1bfb5270&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb5270",
  null
  
)

export default component.exports